const PAGE_SIZE = 10

export const selectedStompunkterOnCurrentPage = (state) => state.selectedStompunkter.slice(...pageBoundaries(currentPage(state)))

const pageBoundaries = (page) => [(page - 1) * PAGE_SIZE, page * PAGE_SIZE]

export const maxPage = (state) => Math.max(1, Math.ceil(state.selectedStompunkter.length / PAGE_SIZE))

export const currentPage = (state) => Math.min(state.selectionPagination, maxPage(state))



// WEBPACK FOOTER //
// ./src/selectors/selectionPagination.js